import {
  SIDEBAR_SET,
} from "../actions/types";

const initialState = {
  sidebarShow: true,
}

export default function (state = initialState, action) {
  switch (action.type) {
    
    case SIDEBAR_SET:
      const rest = {...action}
      delete rest.type
      return { ...state, ...rest };


    default:
      return state;
  }
}
